module.exports = __webpack_public_path__ + "img/tonearm-silver.1c92298e.png";